import React from 'react'
import { withStyles } from '@material-ui/styles';
import { auth } from '../../firestorter'
import * as firebaseui from 'firebaseui';
import * as firebase from 'firebase';

const classes = {
    panel: {
        textAlign: 'center',
        padding: '1rem'
    },
};

class Connect extends React.Component {
    constructor() {
        super()
        
        this.ui = firebaseui.auth.AuthUI.getInstance()
        if(!this.ui){
            this.ui = new firebaseui.auth.AuthUI(auth);
        }
        
        firebase.auth().languageCode = 'iw'
    }
    render() {
        const { classes } = this.props;
        return (
            <div className={classes.panel} style={{ flex: 1 }}>
                <div id="firebaseui-auth-container"></div>
            </div>
        )
    }
    
    componentDidMount() {

        this.ui.start('#firebaseui-auth-container', {
            callbacks: {
                signInSuccessWithAuthResult: function (authResult, redirectUrl) {
                    // User successfully signed in.
                    // Return type determines whether we continue the redirect automatically
                    // or whether we leave that to developer to handle.

                    return true;
                },
            },
            // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
            signInFlow: 'popup',
            signInSuccessUrl: '/',
            signInOptions: [
                // List of OAuth providers supported.
                firebase.auth.GoogleAuthProvider.PROVIDER_ID,
                firebase.auth.EmailAuthProvider.PROVIDER_ID
            ],
            // Other config options...
        });
    }
}

export default withStyles(classes)(Connect);